import Track from "@shared/modules/analytics/components/Track/Track.web";
import Button from "@ui-kit/form/Button/Button.web";
import type { SocialLoginButtonSharedProps } from "./SocialLoginButton.props";

export default function SocialLoginButton(
  props: SocialLoginButtonProps
): JSX.Element {
  const { title, onClick, className, isLoading, icon } = props;
  return (
    <Track.Click analytics={{ label: "social-login-button" }}>
      <Button
        data-testid={`social-login-button-${title}`}
        as="button"
        display="flex"
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
        flexGrow={1}
        borderRadius="xs"
        border="1px solid var(--chakra-colors-gray-400)"
        fontSize="md"
        fontWeight="700"
        backgroundColor="transparent"
        maxWidth="500px"
        _hover={{ backgroundColor: "transparent" }}
        aria-label={title}
        onClick={onClick}
        className={className}
        isLoading={isLoading}
        color="font.dark"
        gap="xs"
      >
        {icon}
        {title}
      </Button>
    </Track.Click>
  );
}

export type SocialLoginButtonProps = SocialLoginButtonSharedProps & {
  // Add any web specific props here.
};
